export default __webpack_public_path__ + "static/media/tickless-parking.inline.3125ceb2.svg";